const route = {
	path: '/dictionary',
	name: 'accounting-dictionary',
	meta: {
		title: 'Diccionario de Datos',
		noChangeCompany: true,
	},
	component: () => import('@/pages/dictionary/page-dictionary'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/dictionary.js